import React, { useState } from 'react';
import { ChevronDown, Lightbulb } from 'lucide-react';

/**
 * A dropdown component to display a block of reasoning text.
 * Animates an icon when reasoning is in progress.
 *
 * ---
 *
 * ### Props:
 * @param {string} reasoningText - The reasoning text to display.
 * @param {boolean} [isReasoning=false] - Optional flag to trigger the pulse animation.
 */
export default function TextReasoningDropdown({ reasoningText, isReasoning = false }) {
  const [open, setOpen] = useState(isReasoning);

  // Don't render anything if there's no text.
  if (!reasoningText) {
    return null;
  }

  return (
    <div className="flex items-start w-full gap-2 mt-2">
      {/* <div className="w-4" />  */}

      <div className="flex flex-col w-full">
        {/* Button to toggle the dropdown */}
        <button
          className="flex items-center py-1 cursor-pointer select-none group"
          onClick={() => setOpen(prev => !prev)}
        >
          <Lightbulb
            className={`h-5 w-5 transition-all duration-300
              ${isReasoning ? 'text-blue-400 animate-pulse' : 'text-zinc-400 group-hover:text-zinc-300'}`}
          />
          <ChevronDown
            className={`ml-2 h-5 w-5 transform transition-transform duration-200
              ${open ? 'rotate-180 text-zinc-300' : 'text-zinc-400 group-hover:text-zinc-300'}`}
          />
        </button>

        {/* The expandable reasoning text block */}
        {/* The expandable reasoning text block with a vertical bar */}
        {open && (
          <div className="flex items-stretch gap-3 pl-1 mt-1 pb-2 pl-1">
            {/* This div creates the vertical bar */}
            <div className="w-0.5 bg-zinc-700 rounded-full" />

            {/* Container for the reasoning text */}
            <div className="">
              <p className="text-xs text-zinc-200 whitespace-pre-wrap">
                {reasoningText?.trim()}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}